import styled from 'styled-components'

export const AdvancedOptionContainer = styled.div`
  margin-top: 52px;
`
